var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { Row, Col } from 'reactstrap';
import classNames from 'classnames';
/**
 *
 */
var CardTitleHeader = /** @class */ (function (_super) {
    __extends(CardTitleHeader, _super);
    /**
     *
     * @param props
     */
    function CardTitleHeader(props) {
        return _super.call(this, props) || this;
    }
    /**
     *
     * @return {*}
     */
    CardTitleHeader.prototype.render = function () {
        var classes = classNames({
            'card-header flex-grow-0 flex-shrink-0': true,
            'card-header--reversed': this.props.isReversed
        });
        return (React.createElement("div", { className: classes },
            React.createElement(Row, { className: "align-items-center" },
                React.createElement(Col, null,
                    React.createElement("h4", { className: "card-header-title" }, this.props.title)),
                React.createElement(Col, { className: "col-auto" }, this.props.children))));
    };
    return CardTitleHeader;
}(React.Component));
export default CardTitleHeader;
